import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Spinner from "../Spinner";
import { SendPostRequest } from "../../http";
import { Link } from "react-router-dom";

function Appointment() {
  const [data, setData] = useState(null);
  const [viewData, setViewData] = useState(null);
  const patientData = useSelector((store) => store.patient.patientLogin);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const requestData = {
          patient_id: patientData?.contact_num,
          // patient_id: "03165573588",
          type: "basic",
        };
        const response = await SendPostRequest(
          "patient/all_appointments",
          requestData
        );
        setData(response?.data);
      } catch (error) {
        console.error("Error fetching dashboard stats:", error);
      }
    };

    fetchData();
  }, []);

  const handleView = async (uid) => {
    try {
      const requestData = {
        appointment_id: uid,
      };
      const response = await SendPostRequest(
        "patient/appointment_detail",
        requestData
      );
      setViewData(response?.data);
    } catch (error) {
      console.error("Error fetching: ", error);
    }
  };

  return (
    <div className="dashboard">
      <h3>Appointment</h3>
      {!data ? (
        <div
          style={{ marginBottom: "100px" }}
          className="d-flex align-items-center justify-content-center"
        >
          <Spinner />
        </div>
      ) : data?.length === 0 ? (
        <div>
          <div className="table-responsive">
            <table className="table">
              <thead className="thead">
                <tr>
                  <th>Doctor Name</th>
                  <th>Requested</th>
                  <th>Approved</th>
                  <th>View</th>
                </tr>
              </thead>
            </table>
          </div>
          <div className="alert text-center fw-bold alert-danger" role="alert">
            No Basic Appointments Found
          </div>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table">
            <thead className="thead">
              <tr>
                <th>Doctor Name</th>
                <th>Requested</th>
                <th>Approved</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((appointment) => (
                <tr key={appointment?.uid}>
                  {/* <td>{appointment?.doctor}</td> */}
                  <td>{appointment?.doctor || "--"}</td>

                  <td style={{ textTransform: "capitalize" }}>
                    {appointment?.requested_time.replace(" 12:00 AM", " - ") +
                      " " +
                      appointment?.shift}
                  </td>
                  <td>{appointment?.approved_date}</td>
                  <td className="d-flex justify-content-between">
                    <button
                      onClick={() => handleView(appointment?.uid)}
                      data-toggle="modal"
                      data-target="#exampleModal"
                    >
                      View
                    </button>
                    {appointment?.arrival_status === "Prescribed" &&
                      appointment?.prescription_link && (
                        <a
                          href={appointment.prescription_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button type="button" className="prescribed-btn-bg-success">Prescribed</button>
                        </a>
                      )}

                    <div
                      class="modal fade appointments-modal-wrapper"
                      id="exampleModal"
                      tabindex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">
                              Appointment Detail
                            </h5>
                            <button
                              type="button"
                              class="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            {viewData && (
                              <div className="row">
                                <div className="col-6">
                                  <h5>Name: </h5>
                                  <p>{viewData[0]?.full_name || "--"}</p>
                                </div>
                                <div className="col-6">
                                  <h5>Doctor: </h5>
                                  <p>{viewData[0]?.doctor || "--"}</p>
                                </div>
                                <div className="col-6">
                                  <h5>Contact Num: </h5>
                                  <p>{viewData[0]?.contact_number || "--"}</p>
                                </div>
                                <div className="col-6">
                                  <h5>Status: </h5>
                                  <p>{viewData[0]?.status || "--"}</p>
                                </div>
                                <div className="col-6">
                                  <h5>Requested Time: </h5>
                                  <p>{viewData[0]?.requested_time || "--"}</p>
                                </div>
                                <div className="col-6">
                                  <h5>Approved Time: </h5>
                                  <p>{viewData[0]?.approved_date}</p>
                                </div>
                              </div>
                            )}
                          </div>

                          <div class="modal-footer">
                            <button
                              type="button"
                              class="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Appointment;
